/*WIP: simple component for viewing JSON (currently no pretty-print)*/

import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';

import JsonTextArea from '../common/JsonTextArea';

const propTypes = {
    analyticsRawData: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        nova_act_inst_id: PropTypes.string,
        data: PropTypes.object,
        created_at: PropTypes.string,
        error: PropTypes.bool,
        error_message: PropTypes.string
    }).isRequired
};

const defaultProps = {};

function AnalyticsRawDataBlock(props) {
    const { id, nova_act_inst_id, data, created_at, error, error_message } = props.analyticsRawData;

    return (
        <Card body bg="light">
            <ul>
                <li><span className="font-weight-bold">ID:</span> {id}</li>
                <li><span className="font-weight-bold">Nova Act Inst ID:</span> {nova_act_inst_id}</li>
                <li><span className="font-weight-bold">Created At:</span> {created_at}</li>
                <li><span className="font-weight-bold">Has Error:</span> {error.toString()}</li>
                <li>
                    <span className="font-weight-bold">Error Message:</span>
                    <div>
                        <code className="codeBlock break-word">{error_message}</code>
                    </div>
                </li>
                <li>
                    <span className="font-weight-bold">Raw Analtyics Data:</span>
                    <div>
                        <JsonTextArea className="width-100p" readOnly json={data} />
                    </div>
                </li>
            </ul>
        </Card>
    );
}

AnalyticsRawDataBlock.propTypes = propTypes;
AnalyticsRawDataBlock.defaultProps = defaultProps;

export default AnalyticsRawDataBlock;